export default __webpack_public_path__ + "static/media/alert.d5436008.svg";